import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { Input } from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { useToast } from '@chakra-ui/react'


import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Textarea


} from "@chakra-ui/react";
import ChilMNodal from "../childModal/childModal";
import CommentBox from "../commentBox/commentBox.jsx";
import Shablon from "../shablon/shablon.jsx";

import Metka from "../metka/metka.jsx";
import Status from "../status/status.jsx";
import SelectMarketPlaceEdit from "../selectMarketPlaceEdit/SelectMarketPlaceEdit";
import ChilMNodalEdit from "../childModalEdit/childModalEdit";
import { getMyCompany } from "../../../../redux/reducer/getCompany/action/action";
import UploadFileTaskMenegerEdit from "../uploadFile/uploadFileEdit";
import Perfomer from "../perfomer/perfomer";
import PerfomerEdit from "../perfomerEdit/perfomerEdit";
import axios from "axios";
import StatusEdit from "../status/statusEdit";
import MetkaEdit from "../metka/editMetka";
import DropdownMobilePioritet from "../tableTask/editPrioritetForMobile/editPrioritetForMobile";
import DropdownMobileStatus from "../tableTask/EditStatusForMobile/editStatusForMobile";

import ChangeDirector from "../changeDirector/changeDirector";
import { useNavigate } from "react-router";
import ModAlForTutorilaVideo from "../tableTask/modAlForTutorilaVideo/modAlForTutorilaVideo";
import LoopingTask from "../loopingTask/loopingTask.jsx";
import { fetchUsers } from "../../../../redux/reducer/postFetcReducer/action/action.js";
import sockets from "../../../../socket/socket.js";


const socket = sockets
function TaskEdit({ editAllTask, itemID, update, allitem, data, handleGetNotify, index, adminInfo }) {
  const dispatch = useDispatch();
  const getmyinfo = useSelector((allWorkers) => allWorkers);
  const myinfos = useSelector(data => data.getMyImageReducer);
  const [show, setShow] = useState(false);
  const [child, setChild] = useState([]);
  const [message, setMessage] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const myModalEditTask = useRef(null)
  const [currentTask, setCurrentTask] = useState([]);
  const [comments, setComments] = useState([]);
  const [performer, setperformer] = useState("");
  const [childperformer, setChildPerformer] = useState([]);
  const [templates, satTemplates] = useState("");
  const [taskName, satTtaskName] = useState("");
  const [templatesArray, satTemplatesArray] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endDateConfirm, setDndDateConfirm] = useState("");
  const [status, setStatus] = useState("");
  const [prioritet, setPrioritet] = useState("");
  const [metka, setMetka] = useState([]);
  const [ozon, setOzon] = useState([]);
  const [wb, setBw] = useState([]);
  const [classNameTask, setclassNameTask] = useState("greyClass");
  const [file, setfile] = useState("");
  const subTaskRed = useRef(null);
  const t = useRef(null);
  const dipatch = useDispatch();
  const [perfomerID, setperfomerID] = useState([]);
  const [load, setload] = useState(false)
  const toast = useToast()
  const [taskInfo, setTasktaskInfo] = useState("");
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [creaTorTask, setcreaTorTask] = useState("")
  let getmyinfoForAdd = useSelector(compID => compID.getMayInfoReducer)
  const getDarkModoe = useSelector(darkModes => darkModes)
  const gerChekcedCompany = useSelector((allWorkers) => allWorkers);
  const navigate = useNavigate()

  const [checked,setChecked] = useState(false)
  const [selectDays,setselectDays] = useState("everyDay")
  const [loopingStartDate,setloopingStartDate] = useState(new Date().toISOString().slice(0, 16))
  const [everythreedays,seteverythreedays] = useState(new Date())
  const [creatorTaskinfo,setcreatorTaskinfo] = useState("")
  let onlineUSers = useSelector(onlineUSers => onlineUSers)
useEffect(()=>{
    // console.log(allitem.creatorTasks);
    // console.log(getmyinfoForAdd.myinfo._id);
   
    if (getmyinfoForAdd?.myinfo?._id == allitem.creatorTasks) {
      setcreatorTaskinfo(getmyinfoForAdd?.myinfo)
    }else {
      gerChekcedCompany.rootReducer.users.data?.forEach(finduser => {
            if (finduser.workerID == allitem.creatorTasks) {
              setcreatorTaskinfo(finduser)
              return
            }else{
              setcreatorTaskinfo("")
            }
      });
    }
},[""])

  useEffect(() => {
      console.log(allitem,"editAllTaskeditAllTaskeditAllTaskeditAllTaskeditAllTaskeditAllTaskeditAllTask");
    // socket.emit('pushmyid', getmyinfoForAdd.myinfo._id);
    // console.log(editAllTask,'editAllTask'); veradarcnum e  alltask arrayi mejin@ 
    //  console.log(itemID,'itemID'); veradracnum e id
    // console.log(allitem,'allitem'); veradarcnum e henc amboxj@
    //  console.log(data,'data'); 
    // socket.on('online', (users) => {
    //   setOnlineUsers(users);
    // });
    return () => {

      // socket.off('online');
      // socket.off('disconnect');


    };
  }, [])

  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
  useEffect(() => {
    let currentDate = new Date().toISOString().slice(0, 16)







    dipatch(getMyCompany("/mycopany/getallcompany"));
    switch (prioritet) {
      case "Критический":

        setclassNameTask("urgentAndImportant");
        break;
      case "Важно":

        setclassNameTask("LilacClass");
        break;
      case "Срочно":

        setclassNameTask("yellowClass");
        break;
      default:

        setclassNameTask("greyClass");
    }
    setCurrentTask(editAllTask[0]);
    setCurrentTask([
      {
        child,
        taskName,
        msg: message,
        comments,
        performer,
        startDate,
        endDate,
        status,
        prioritet,
        ozon,
        wb,
        classNameTask,
        file,
        perfomerID,
        taskInfo,
        metka
      },
    ]);


  }, [
    comments,
    performer,
    templates,
    templatesArray,
    startDate,
    endDate,
    status,
    prioritet,
    metka,
    child,
    wb,
    ozon,
    taskName,
    file,
    taskInfo,


  ]);

  let array = [];

  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const setSubStack = (e) => {

    if (e.key === "Enter") {

      setChild([
        ...child,
        {
          child: [],
          taskName,
          msg: message,
          comments: [],
          performer: [],
          startDate: "",
          endDate: getCurrentDateTime(),
          status: "",
          prioritet: "",
          file: "",
          taskInfo: "",
          metka
        },
      ]);

      setMessage("");
      subTaskRed.current.style.overflow = "auto";

    }
  };



  const setSubStackBTN = (e) => {
    var d = new Date();

    if (message != "") {
      dispatch(fetchUsers())
      const currentDate = new Date();
      setChild([
        ...child,
        {
          child: [],
          taskName,
          msg: message,
          comments: [],
          performer,
          startDate: "",
          endDate: getCurrentDateTime(),
          status: "",
          prioritet: "",
          file: "",
          taskInfo: "",
          metka,
          key:getRandomInt(1000000000000000000)
        },
      ]);

      setMessage("");
      subTaskRed.current.style.overflow = "auto";

    }

  }


  useEffect(() => {
    setcreaTorTask(allitem.creatorTasks)
    setCurrentTask(editAllTask[0]);
    setBw(editAllTask[0].wb);
    setOzon(editAllTask[0].ozon);
    setChild(editAllTask[0].child);
    setComments(editAllTask[0].comments);
    setStartDate(editAllTask[0].startDate);
    setEndDate(editAllTask[0].endDate);
    setPrioritet(editAllTask[0].prioritet);
    setStatus(editAllTask[0].status);
    setperformer(editAllTask[0].performer);
    setclassNameTask(editAllTask[0].classNameTask);
    satTtaskName(editAllTask[0].taskName);
    setfile(editAllTask[0].file);
    setperfomerID(allitem.perfomerID)
    setTasktaskInfo(editAllTask[0].taskInfo)
    setMetka(editAllTask[0].metka)
    setChecked(allitem.isLooping)
    setselectDays(allitem.typeLooping)
    setloopingStartDate(allitem.loopingStartDate)
      console.log(allitem);

  }, [data])


  const getarraa = (item, index) => {
    if (item.child.length === 0) {
      array = [];
      array.push(child);
      array[0][index].child.push();
    }
  };



  const showModal = () => {

    handleShow();


    setCurrentTask(editAllTask[0]);
    setBw(editAllTask[0].wb);
    setOzon(editAllTask[0].ozon);
    setChild(editAllTask[0].child);
    setComments(editAllTask[0].comments);
    setStartDate(editAllTask[0].startDate);
    setEndDate(editAllTask[0].endDate);
    setPrioritet(editAllTask[0].prioritet);
    setStatus(editAllTask[0].status);
    setperformer(editAllTask[0].performer);
    setclassNameTask(editAllTask[0].classNameTask);
    satTtaskName(editAllTask[0].taskName);
    setfile(editAllTask[0].file);
    setperfomerID(allitem.perfomerID)
    setMetka(editAllTask[0].metka)

  };

  const sendServer = () => {

    if (editAllTask[0] && editAllTask[0].perfomerID && editAllTask[0].perfomerID[0]) {
      if (editAllTask[0].perfomerID[0].workerID && perfomerID[0] && perfomerID[0].workerID) {
        if (editAllTask[0].perfomerID[0].workerID == perfomerID[0].workerID) {

        } else {
          if (perfomerID[0] && perfomerID[0].workerID) {
            if (perfomerID[0].email) {


              axios.post('/sendEmail/api', {
                perfomerEmail: perfomerID[0].email
              })
                .then(function (response) {

                })
                .catch(function (error) {
                  console.log(error);
                });
            } else {

              toast({
                position: "top",
                title: 'У этого пользователя нет электронной почты',
                description: "У этого пользователя нет электронной почты",
                status: 'error',
                duration: 2000,
                isClosable: true,
              });
            }

          }
        }
      }
    } else {
      if (perfomerID[0] && perfomerID[0].workerID) {
        if (perfomerID[0].email) {


          axios.post('/sendEmail/api', {
            perfomerEmail: perfomerID[0].email
          })
            .then(function (response) {

            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          console.log("no Email");
          toast({
            position: "top",
            title: 'У этого пользователя нет электронной почты',
            description: "У этого пользователя нет электронной почты",
            status: 'error',
            duration: 2000,
            isClosable: true,
          });
        }

      }
    }

    if (editAllTask[0].child.length > 0) {

      console.log(editAllTask[0].child);
    } else {

    }





    setload(true)
    console.log(creaTorTask, "creaTorTask");
    allitem.perfomerID = perfomerID
    allitem.allmetka = metka
   
    
    axios.post('/findAndUpdateTask', {
      itemID,
      currentTask,
      allitem,
      perfomerID: allitem.perfomerID,
      allmetka: metka,
      creaTorTask,
      isLooping:checked,
      selectDays,
      loopingStartDate,
      everythreedays
    })
      .then(function (response) {
        sendSeverCreatNotifyForTask();   
        update();
        setload(false);
        handleClose();
        navigate("/task");

      })
      .catch(function (error) {
        console.log(error);
        setload(false);
      });




  };


  const HandleSetPerfomerId = (e) => {

    setperfomerID([e])
    setperformer(e)
  }

  const HandleDeletePerfomerId = (e) => {
    setperformer("")
    setperfomerID([])
  }

  function deleteItemByIndex(index) {
    setChild(prevArray => {
      const newArray = [...prevArray]; // Create a new array copy
      newArray.splice(index, 1); // Remove the element at the specified index
      return newArray; // Update the state with the modified array
    });
  }



  const handleDate = () => {

    axios.post('/notifyConfirm', {
      eidtTaskID: allitem._id,
      isChild: false,
      adminIDTask: allitem.creatorTasks.toString(),
      typenotify: "date",
      indexTask: 0,
      senderName: getmyinfo.getMayInfoReducer.myinfo.name,
      senderTel: getmyinfo.getMayInfoReducer.myinfo.tel,
      senderEmail: getmyinfo.getMayInfoReducer.myinfo.email,
      text: "",
      messageConfirm: endDateConfirm,
      taskName,
      oldDate: editAllTask[0].endDate,
      myAvatar: myinfos.users.myavatar

    })
      .then(function (response) {
        console.log(response);
        handleGetNotify()
        toast({
          position: "top",
          title: 'Отправлено на подтверждение постановщику задачи',
          description: "Отправлено на подтверждение постановщику задачи",
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleStatus = () => {
    axios.post('/notifyConfirm', {
      eidtTaskID: allitem._id,
      isChild: false,
      adminIDTask: allitem.creatorTasks.toString(),
      typenotify: "status",
      indexTask: 0,
      senderName: getmyinfo.getMayInfoReducer.myinfo.name,
      senderTel: getmyinfo.getMayInfoReducer.myinfo.tel,
      senderEmail: getmyinfo.getMayInfoReducer.myinfo.email,
      text: "",
      messageConfirm: endDate,
      taskName,
      oldDate: editAllTask[0].endDate,
      myAvatar: myinfos.users.myavatar

    })
      .then(function (response) {

        handleGetNotify()
        toast({
          position: "top",
          title: 'Отправлено на подтверждение постановщику задачи',
          description: "Отправлено на подтверждение постановщику задачи",
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleChangeFile = (e) => {
    console.log("prent");
    setfile(e)

  }



  const handleCloseModal = () => {
    myModalEditTask.current.style.display = "none"
  }


  function dateisCurrent() {
    let currentDate = new Date();

    if (currentDate >= new Date(endDate)) {
        return true;
    } else {
        return false;
    }
}

// этот функция для того чтобы создать уведомление для задач
async function sendSeverCreatNotifyForTask(e) {
  if (new Date(endDate).getTime() != new Date(allitem.alltask[0].endDate).getTime()) {
    if (allitem.alltask[0].performer) {
      // получаем информацию о пользователе
      const userInfo = await axios.get(`/getuserByID/api?userID=${allitem.creatorTasks}`);
      let mount = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];
      const covertDate = new Date(endDate).getDay() + " "+ mount[new Date(endDate).getMonth()] + " " + new Date(endDate).getFullYear()
      let notifyText = `${userInfo.data.data.name} изменил срок окончания <a target="_blank" class="taskName" href="getCurrentTask/${allitem._id}">${allitem.alltask[0].taskName}</a> на ${covertDate}  конца.`
      axios.post('/creatNotifyForTaskInfo/api', {
          // здесь не проверяем Это задача и подзадача
          isChild:false,
          // здесь мы отправляем полное задание
          task:allitem,
          //  // если это подзадача тогда получаем индекс этого подзадачу
          index:1234,
           // здесь мы отправляем текст для уведомлений
          notifyText,
          // кому нужно отправить этот уведомление мы берём идентификатор этого пользователя
          notificationRecipientID:allitem.alltask[0].performer.workerID,
          // информация пользователя для отправления уведомлений на электронную почту
          emailInfo:{
              // здесь мы отправляем идентификатор пользователя
              userIdForEmail:allitem.alltask[0].performer.workerID,
              // текст для заголовки
              subject:"Смена срока окончания задачи",
              // текст для электронную почту
              textEmail:`${userInfo.data.data.name} изменил срок окончания <a target="_blank" class="taskName" href="https://xn--h1alceggc.xn--p1ai/getCurrentTask/${allitem._id}">${allitem.alltask[0].taskName}</a> на ${covertDate}  конца.`
          }
      })
      .then(function (response) {
          console.log(response);
          socket.emit('getNotifyEmit');
      })
      .catch(function (error) {
          console.log(error);
      });
    }
}
   

}

  return (
    <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "modalCreatTaskDark" : "modalCreatTask"}>

      <div className="modalCont">
        <div className="perfomerAndShef">

          <div className="perfomerAndShefDiv">
            <ChangeDirector creaTorTask={creaTorTask} setcreaTorTask={setcreaTorTask} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId} onlineUsers={onlineUSers.getOnlineUserViaRouterReducer.users.data} adminInfo={adminInfo} />
            <PerfomerEdit performerS={performer} setperformerS={setperformer} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId} onlineUsers={onlineUsers} allitem={allitem}/>

            {/* <PerfomerEdit performerS={performer} setperformerS={setperformer} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId} onlineUsers={onlineUsers} /> */}
          </div>
          <div className="statusANDprioritet">
            <DropdownMobilePioritet isChild={false} prioritetGet={allitem.alltask[0].prioritet} allitemForStatus={allitem} index={index} update={update} />
            <DropdownMobileStatus isChild={false} statusGet={allitem.alltask[0].status} allitemForStatus={allitem} index={index} update={update} />

          </div>
          <div className='ContentTutorial'>
            <ModAlForTutorilaVideo />
            <div className='andDiv'>
              <p>или</p>
            </div>
            <div className='allCursDiv'>
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="22" viewBox="0 0 28 22" fill="none">
                <path d="M1.37099 16.8223V3.60571C0.904866 3.7291 0.43868 3.87994 0 4.01702V20.7022C3.68009 19.6851 7.59062 19.8871 11.1463 21.278C9.94998 20.0684 8.52599 19.1076 6.95647 18.4511C5.38696 17.7946 3.70298 17.4553 2.00169 17.4529C1.83553 17.4494 1.67714 17.3819 1.55961 17.2644C1.44208 17.1468 1.3745 16.9884 1.37099 16.8223Z" fill="#3B79F6" />
                <path d="M2.65929 0L2.61816 16.2601C4.61435 16.3635 6.56738 16.8799 8.35379 17.7767C10.1402 18.6734 11.7212 19.931 12.9967 21.47V5.96389C11.8345 4.25495 10.3011 2.83086 8.51097 1.79811C6.72087 0.765352 4.72045 0.150661 2.65929 0ZM25.8293 3.63315V16.836C25.8258 17.0021 25.7583 17.1605 25.6407 17.278C25.5232 17.3956 25.3648 17.4631 25.1987 17.4666C23.5013 17.4681 21.8212 17.8071 20.256 18.4637C18.6908 19.1204 17.2718 20.0817 16.0815 21.2917V21.3054C19.6255 19.9095 23.5261 19.6979 27.2003 20.7021V4.04439C26.7616 3.89362 26.3092 3.74285 25.8293 3.63315Z" fill="#3B79F6" />
                <path d="M24.5963 0C22.5277 0.135618 20.5177 0.743742 18.7209 1.77763C16.9241 2.81151 15.3882 4.24363 14.2314 5.96389V21.47C15.5054 19.9327 17.0842 18.676 18.8681 17.7793C20.6521 16.8827 22.6024 16.3654 24.5963 16.2601V0Z" fill="#3B79F6" />
              </svg>
              <p style={{ width: "5rem" }}>Обучающий курс</p>

            </div>


          </div>
        </div>
        <div className="inputCreatTask">

          <div className="taskinputsDiv">
            <MetkaEdit setMetka={setMetka} metka={metka} />
            <p className="taskName">Введите название задачи</p>
            <input
              placeholder="Введите название задачи"
              className="nameTaskInput"
              value={taskName}
              onChange={(e) => satTtaskName(e.target.value)}
            />
                         
              {/* date */}
            <div style={{ margin: "30px 0" }}>
              <p className="srok">Сроки</p>
              {(() => {

                if (allitem.creatorTasks === getmyinfo.getMayInfoReducer.myinfo._id) {
                  return (
                    <div className="date" >

                      <label htmlFor="startDate">
                        Дата начала:
                        <input
                        id="startDate"
                          size="sm"
                          type="datetime-local"
                          colorScheme="grey"
                          value={startDate}
                        
                          onChange={(e) => setStartDate(e.target.value)}
                         
                          
                        />
                      </label>
                      <label htmlFor="endDate">
                        Дата конца:
                        <input
                        id="endDate"
                          size="sm"
                          type="datetime-local"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          style={
                            dateisCurrent() ? { color: "red" } : { border: "#707A99"}
                          }
                        />

                      </label>
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M9.5 20H2.5C1.39 20 0.5 19.1 0.5 18L0.51 4C0.51 2.9 1.39 2 2.5 2H3.5V1C3.5 0.45 3.95 0 4.5 0C5.05 0 5.5 0.45 5.5 1V2H13.5V1C13.5 0.45 13.95 0 14.5 0C15.05 0 15.5 0.45 15.5 1V2H16.5C17.6 2 18.5 2.9 18.5 4V10H16.5V8H2.5V18H9.5V20ZM19.63 14.99L20.34 14.28C20.73 13.89 20.73 13.26 20.34 12.87L19.63 12.16C19.24 11.77 18.61 11.77 18.22 12.16L17.51 12.87L19.63 14.99ZM18.92 15.7L13.91 20.71C13.73 20.89 13.47 21 13.21 21H12C11.72 21 11.5 20.78 11.5 20.5V19.29C11.5 19.02 11.61 18.77 11.79 18.58L16.8 13.57L18.92 15.7Z" fill="#3B79F6" />
                      </svg>
                    </div>
                  )
                } else {
                  return (
                    <div className="date">
                      <label htmlFor="startDate">
                        Дата начала:
                        <input
                        id="startDate"
                          size="sm"
                          type="datetime-local"
                          colorScheme="grey"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          disabled
                        
                        />
                      </label>
                      <label htmlFor="endDate">
                        Дата конца:
                        <input
                        id="endDate"
                          size="sm"
                          type="datetime-local"
                          defaultValue={endDate}
                          onChange={(e) => setDndDateConfirm(e.target.value)}
                          key={endDate}
                          style={
                            dateisCurrent() ? { color: "red" } : { border: "#707A99"}
                          }
                        />

                      </label>
                      <button onClick={handleDate} className="confirmEditDate">Запросить подтверждение</button>
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M9.5 20H2.5C1.39 20 0.5 19.1 0.5 18L0.51 4C0.51 2.9 1.39 2 2.5 2H3.5V1C3.5 0.45 3.95 0 4.5 0C5.05 0 5.5 0.45 5.5 1V2H13.5V1C13.5 0.45 13.95 0 14.5 0C15.05 0 15.5 0.45 15.5 1V2H16.5C17.6 2 18.5 2.9 18.5 4V10H16.5V8H2.5V18H9.5V20ZM19.63 14.99L20.34 14.28C20.73 13.89 20.73 13.26 20.34 12.87L19.63 12.16C19.24 11.77 18.61 11.77 18.22 12.16L17.51 12.87L19.63 14.99ZM18.92 15.7L13.91 20.71C13.73 20.89 13.47 21 13.21 21H12C11.72 21 11.5 20.78 11.5 20.5V19.29C11.5 19.02 11.61 18.77 11.79 18.58L16.8 13.57L18.92 15.7Z" fill="#3B79F6" />
                      </svg>


                    </div>
                  )
                }
              })()}

            </div>
                {/* date End */}
                <LoopingTask setChecked={setChecked} checked={checked}  selectDays={selectDays} setselectDays={setselectDays} 
                          loopingStartDate={loopingStartDate} setloopingStartDate={setloopingStartDate} everythreedays={everythreedays} seteverythreedays={seteverythreedays} creatTaskadminInfo={creatorTaskinfo}/>

            <p className="taskDeskriptionText">Добавьте описание задачи</p>
            <textarea placeholder="Здесь вы можете добавить описание к выбранной задаче" className="taskDeskription" defaultValue={taskInfo} onChange={(e) => setTasktaskInfo(e.target.value)} />
           
            <SelectMarketPlaceEdit
              setBw={setBw}
              setOzon={setOzon}
              wbs={wb}
              ozons={ozon}
              show={show}
            />
            {/* <Shablon sendMessage={sendMessage} currentTask ={currentTask} perfomerID={perfomerID} receivedMessages={receivedMessages}  handleDelet={handleDelet} delLoad={delLoad} update={update} handleGetNotify={handleGetNotify} closeParent={handleClose}/> */}




            <UploadFileTaskMenegerEdit file={file} setfile={setfile} allitem={allitem} index={0} isChild={false} handleChangeFile={handleChangeFile} />
          </div>

          <div className="taskinputsDiv2">

            <div className="addSubTask">
              <p style={{ color: '#6A717F' }}>Подзадачи</p>
              <div>
                <input
                  className="SubTaskInput"
                  placeholder="Введите название подзадачи"
                  value={message}
                  onKeyDown={setSubStack}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <button className="addTaskButton" onClick={(e) => setSubStackBTN(e.target.value)}>Добавить</button>
              </div>

            </div>
            <div className={getDarkModoe.ToggleDarkModeReducer.chekced ? "subTaskDark" : "subTask"}
              style={{ overflow: "auto" }} ref={subTaskRed}>





              {child?.map((item, index) => {
                console.log(item,"itemPredf");
                return (
                  <div onClick={() => getarraa(item, index)} className={getDarkModoe.ToggleDarkModeReducer.chekced ? "childTaskContDark" : "childTaskCont"} key={index}>

                    <div className="itemChild">
                      {/* <h6>#{index+1}</h6>
                          <p>{item.msg}</p>
                          <p>{item.startDate.split("T").join(",")}</p> */}
                      {/* <p>{item.startDate.split("T").join(",")}-{item.endDate.split("T").join(",")}</p> */}

                      <ChilMNodalEdit
                        item={item}
                        allaray={currentTask}
                        nameCurrentSubTask={item.msg}
                        sendServer={sendServer}
                        load={load}
                        editAllTask={editAllTask}
                        allitem={allitem}
                        index={index}
                        handleGetNotify={handleGetNotify}
                        key={item + index}
                        handleClose={handleClose}
                        update={update}
                        deleteItemByIndex={deleteItemByIndex}
                      />
                    </div>

                    {/* <span class="material-symbols-outlined deletSubTusk" onClick={() => deleteItemByIndex(index)}>delete</span> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" onClick={() => deleteItemByIndex(index)}>
  <path d="M3.08594 13.2509C2.73145 13.2509 2.42798 13.1466 2.17554 12.9379C1.9231 12.7293 1.79688 12.4785 1.79688 12.1855V2.06481H0.916016V0.999467H4.95508V0.466797H10.627V0.999467H14.666V2.06481H13.7852V12.1855C13.7852 12.4696 13.6562 12.7182 13.3984 12.9313C13.1406 13.1444 12.8398 13.2509 12.4961 13.2509H3.08594ZM12.4961 2.06481H3.08594V12.1855H12.4961V2.06481ZM5.36328 10.6586H6.65234V3.57404H5.36328V10.6586ZM8.92969 10.6586H10.2187V3.57404H8.92969V10.6586Z" fill="#E62E7B"/>
</svg> */}
                  </div>
                );
              })}
            </div>


            {/* ====================== */}


            {/* <StatusEdit setStatus={setStatus} status={status} creatorTasks={allitem.creatorTasks} /> */}
            {/* {(() => {
                  if (allitem.creatorTasks !== getmyinfo.getMayInfoReducer.myinfo._id) {
                    return (
                      <button onClick={handleStatus} className="confirmEditDate">Сдать работу</button>
                    )
                  }
                })()} */}


            {/* <MetkaEdit setMetka={setMetka} metka={metka} /> */}
            <CommentBox setComments={setComments} comments={comments} key={"ASDASDASDASD"} isChild={false} allitem={allitem} editAllTask={editAllTask} update={update} onlineUsers={onlineUsers}  sendServer={sendServer}/>
          </div>
        </div>
        <div className="footerCreatTask">
        {
          load ?
            <button disabled> Загрузка</button>
            :
            <button className="EditSaveBtn" onClick={sendServer}> Сохранить</button>
        }
        </div>
      </div>
      {/* <div className="currentTaskButton">

        {
          load ?
            <button disabled> Загрузка</button>
            :
            <button className="EditSaveBtn" onClick={sendServer}> Сохранить</button>
        }
      </div> */}


    </div>
  )
}

export default TaskEdit;
